import { LOCAL_STORAGE } from 'app/commons/constants'
import { ICON_DELIVEREE_GREEN, ICON_TRANSPORTIFY_GREEN } from 'app/commons/constants/image.const'
import { hideLoading, showLoading } from 'app/commons/helpers/loadingUtils'
import * as Utils from 'app/commons/helpers/utils'
import * as authAction from 'app/store/auth/authAction'
import { modalCreateActions } from 'app/store/modal/modalSlice'
import { getAndCheckTokenCaptCha } from 'app/utils/authentication'
import { Formik } from 'formik'
import PropTypes from 'prop-types'

import React from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import _get from 'lodash.get'

import './style.scss'

const INIT_VALUES = {
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  password: '',
  country_code: 'id',
  access_token: '',
  referred_code: '',
  business_name: '',
  provider: '',
}

const ModalMerge = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { executeRecaptcha } = useGoogleReCaptcha()

  const data = useSelector((state) => state.configuration.data)
  const enableCaptchaVerification = useSelector((state) => state.configuration.data?.enable_captcha_verification)
  const countryCode = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY)
  const tcLink = _get(data, 'tc_link.non_bp', '')
  const privatePolicyURL = _get(data, 'privacy_policy_link', '')
  const LOGO_ICON = countryCode === 'ph' ? ICON_TRANSPORTIFY_GREEN : ICON_DELIVEREE_GREEN

  const renderInputField = (inputName, inputLabel, propsFiled, isEdit = false) => {
    return (
      <div className="form-row mb-3">
        <div className="form-group col-md-12">
          <label htmlFor={inputName}>{t(inputLabel)}</label>
          <div className="input-group">
            {isEdit ? (
              <input
                type="text"
                className="form-control"
                id={inputName}
                name={inputName}
                value={propsFiled?.values?.[inputName]}
                onChange={propsFiled.handleChange}
                onBlur={propsFiled.handleBlur}
              />
            ) : (
              <input
                type="text"
                className="form-control disabled-input"
                id={inputName}
                name={inputName}
                value={propsFiled?.values?.[inputName]}
              />
            )}
          </div>
        </div>
      </div>
    )
  }

  const signUp = async (values) => {
    showLoading()
    const dataInfo = { ...values }
    dataInfo.first_name = dataInfo.first_name ? dataInfo.first_name.trim() : dataInfo.first_name
    dataInfo.last_name = dataInfo.last_name ? dataInfo.last_name.trim() : dataInfo.last_name
    dataInfo.email = dataInfo.email ? dataInfo.email.toLowerCase() : dataInfo.email

    const onSignUpSuccess = (dataResult) => {
      localStorage.removeItem(LOCAL_STORAGE.SIGNUP_INFORMATION_LOCAL)
      dispatch(modalCreateActions.closeModal())
      dispatch(authAction.handleGetAuth({ accountId: dataResult.id, hideLoading }))
      hideLoading()
    }
    const onSignUpError = (message) => {
      hideLoading()
      toast.error(message)
    }
    let xRecaptchaToken
    if (enableCaptchaVerification) {
      xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'signup')
    }
    dispatch(authAction.postSignUp({ dataInfo, onSignUpSuccess, onSignUpError, xRecaptchaToken }))
  }

  return (
    <>
      <Formik
        initialValues={props?.initialValues || INIT_VALUES}
        onSubmit={(values, { setSubmitting }) => {
          signUp(values)
          setSubmitting(false)
        }}
      >
        {(propsForm) => (
          <div className="popup-auth">
            <div className="auth-body merge-modal">
              <div className="auth-close">
                <i
                  onClick={() => dispatch(modalCreateActions.closeModal())}
                  className="material-icons"
                  role="presentation"
                >
                  close
                </i>
              </div>
              <div className="auth-logo">
                <img src={LOGO_ICON} alt="deliveree" />
              </div>
              <div className="already-account-text">
                {t('signup.alreadyHaveAccount', { app_name: Utils.appName() })}{' '}
              </div>
              <div className="merge-container">
                <form onSubmit={propsForm.handleSubmit}>
                  {renderInputField('email', 'signup.emailLabel', propsForm)}
                  {renderInputField('phone', 'signup.mobilePhone', propsForm)}
                  {renderInputField('first_name', 'signup.firstNameLabel', propsForm)}
                  {renderInputField('last_name', 'signup.lastNameLabel', propsForm)}
                  {renderInputField('business_name', 'signup.businessNameLabel', propsForm, true)}
                  {renderInputField('referred_code', 'signup.referralCodeLabel', propsForm, true)}
                  <div className="merge-form--submit text-center">
                    <button type="submit" className="Button h36 green w-100">
                      {t('signup.singupButton')}
                    </button>
                  </div>
                  <div
                    className="signup-form--footer"
                    dangerouslySetInnerHTML={{
                      __html: t('signup.byClicking', {
                        term_link: tcLink,
                        privacy_link: privatePolicyURL,
                        app_name: Utils.appName(),
                      }),
                    }}
                  />
                </form>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </>
  )
}

ModalMerge.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
}

ModalMerge.defaultProps = {}

export default ModalMerge
